import * as React from 'react';
import {Box} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import ReplayIcon from '@mui/icons-material/Replay';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import useStore from "../../../../store/store";
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import style from './amplitudeMonitor.css'

export default function AmplitudeMonitorComponent() {

    const eng = useStore((state) => state.eng);
    const generatorOn = useStore((state) => state.generatorOn);
    const amplitudeGeneratorsRegulatorValue = useStore((state) => state.amplitudeGeneratorsRegulatorValue);
    const changeAmplitudeGeneratorsRegulatorValue = useStore((state) => state.changeAmplitudeGeneratorsRegulatorValue);

    const handleIncrement = () => {
        const newValue = parseFloat(amplitudeGeneratorsRegulatorValue) + 0.01;
        if (newValue <= 9.99) {
            changeAmplitudeGeneratorsRegulatorValue(newValue.toFixed(2));
        }
    };

    const handleDecrement = () => {
        const newValue = parseFloat(amplitudeGeneratorsRegulatorValue) - 0.01;
        if (newValue >= 0) {
            changeAmplitudeGeneratorsRegulatorValue(newValue.toFixed(2));
        }
    };

    const handleIncrementMore = () => {
        const newValue = parseFloat(amplitudeGeneratorsRegulatorValue) + 0.25;
        if (newValue <= 9.99) {
            changeAmplitudeGeneratorsRegulatorValue(newValue.toFixed(2));
        }
    };

    const handleDecrementMore = () => {
        const newValue = parseFloat(amplitudeGeneratorsRegulatorValue) - 0.25;
        if (newValue >= 0) {
            changeAmplitudeGeneratorsRegulatorValue(newValue.toFixed(2));
        }
    };

    const handleReset = () => {
        changeAmplitudeGeneratorsRegulatorValue(0);
    };

    const handleResetRight = () => {
        changeAmplitudeGeneratorsRegulatorValue(9.99);
    };

    return (
        <Box sx={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
            <Box className="monitor">
                <Box sx={{ width: '100%', position: 'absolute', textAlign: 'center', fontSize: '100%' }}>
                    {generatorOn ? amplitudeGeneratorsRegulatorValue : null}
                </Box>
            </Box>
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Box sx={{display: 'flex', marginTop: '10px'}}>
                    <button className="buttonForAmplitudeMonitor" onClick={handleReset}><KeyboardDoubleArrowLeftIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleDecrementMore}><FastRewindIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleDecrement}><ReplayIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleIncrement}><RefreshIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleIncrementMore}><FastForwardIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleResetRight}><KeyboardDoubleArrowRightIcon className="buttonForAmplitudeMonitor"/></button>
                </Box>
            </Box>
                <Box className="textMonitor">
                    {eng ? 'AMPLITUDE' : 'АМПЛІТУДА'} U<sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}><sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>{eng ? 'p' : 'п'}</sub></sub>, {eng ? 'V' : 'B'}
                </Box>
            </Box>
        </Box>
    );
};
